<!--  -->
<template>
  <div class="tablwbox">
    <div class="srrwrw">
      <div>
        <!-- <el-input v-model="paquery.keywords" placeholder="请输入小程序名/appid" style="width:200px;margin-right:10px" /> -->
        <el-autocomplete
          v-model="assort_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请选择类型"
          @select="handleSelect"
        />
        <el-button type="primary" icon="el-icon-search" style="margin-left:10px" @click="srarch">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="add">新增</el-button>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      min-height="900"
      style="width: 100%;"
    >
      <el-table-column
        prop="final_id"
        label="图片ID"
        width="300"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.final_info.final_id }}
        </template>
      </el-table-column>
      <el-table-column
        prop="final_id"
        label="封面图"
        width="300"
        align="center"
      >
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.final_info.final_url"
            fit="cover"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="level_count"
        label="可玩次数"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.final_info.level_count }}
        </template>
      </el-table-column>
      <el-table-column
        prop="assort_name"
        label="类型"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.final_info.assort_name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="final_id"
        label="创建时间"
        width="300"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.create_at_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at_text"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="edit(scope.row.final_info.final_id)">编辑</el-button>
          <el-button type="danger" size="mini" @click="deleter(scope.row.final_info.final_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
  </div>
</template>

<script>
import { iconsSetlist, underlaydelete, assortlist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  name: 'Wechatseting',
  components: {
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      paquery: {
        page: 1,
        page_size: 10,
        assort_id: null
      },
      total: null,
      tableData: [],
      qrcode: '',
      loading: false,
      imageData: '',
      assort_name: ''
    }
  },
  activated() {
    this.sawrlist()
  },
  created() {
    this.sawrlist()
  },
  mounted() {

  },
  methods: {
    async sawrlist() {
      this.loading = true
      const data = await iconsSetlist(this.paquery)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data.data)
    },

    // 搜索手机编号
    async querySearchAsync(value, cb) {
      const data = await assortlist({ name: value, page: 1, page_size: 100 })
      cb(data.data.list.map((item) => { return { ...item, value: item.name, address: item.id } }))
    },
    fetchPageSizeone(e) {
      this.paquery.page_size = e
      this.sawrlist()
    },
    fetchCurrentPageone(e) {
      this.paquery.page = e
      this.sawrlist()
    },
    srarch() {
      this.paquery.page = 1
      this.sawrlist()
    },
    reset() {
      this.paquery.page = 1
      this.paquery.page_size = 10
      // this.paquery.keywords = null
      this.paquery.assort_id = null
      this.assort_name = ''
      this.sawrlist()
    },
    enlarge(url) {
      this.qrcode = url
      this.dialogVisible = true
    },
    add() {
      this.$router.push({ path: '/seelook/index', query: { type: 1 }})
    },
    edit(final_id) {
      this.$router.push({ path: '/seelook/index', query: { type: 2, final_id: final_id }})
    },
    callback() {
      this.dialogVisible = false
      this.sawrlist()
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    deleter(final_id) {
      console.log('final_id', final_id)
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        underlaydelete({
          final_id: final_id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.sawrlist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    handleSelect(item) {
      console.log(item)
      this.paquery.assort_id = item.id
      this.assort_name = item.name
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tablwbox{
  padding: 20px;
}
.srrwrw{
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
</style>
